import { gql } from '@grandvisionhq/graphql';
import { recoverInactiveCartFailure } from './recover-inactive-cart-failure.js';

const recoverInactiveCartResult = gql`
  fragment RecoverInactiveCartFragment on OrderedCheckoutResponse {
    newCheckoutId
    checkoutHash
    failures {
      ...RecoverInactiveCartFailureFragment
    }
    success
  }
  ${recoverInactiveCartFailure}
`;

export { recoverInactiveCartResult };
//# sourceMappingURL=recover-inactive-cart-result.js.map
